module.exports = __webpack_public_path__ + "assets/img/81494c7ee24eed3428f01463fcd7c623.png";